import { NormalizedTransaction } from 'src/app/models/normalized-models/normalized-transaction.model';

/**
 * POS-972 On-Screen Signature.
 * `TransactionLookupService.patchTransactionSignature` is a raw HTTP call (bypasses NGXS), so
 * without this the `transactions` state slice — and therefore `UtilsSelectors.selectedTicket`'s
 * denormalized transactions — stays stale after a signature is captured/skipped.
 */
export class PatchTransactionSignature {
  static readonly type = '[Transactions] Patch Transaction Signature';
  constructor(
    public transactionId: number,
    public data: Partial<
      Pick<NormalizedTransaction, 'signature_status' | 'signature_captured_at'>
    >
  ) {}
}
